export const accessRights = {
    "BANKER_MANAGER": '001',
    "SENIOR_MANAGER": '002',
};